import { dynamicLoader } from '~/utils';

export const CompanyAddressEditor = dynamicLoader({
  name: 'CompanyAddressEditorWrapper',
  importFunc: () => import('./company-address-editor-wrapper'),
});